import PhaseIIIHero from "./components/PhaseIIIHero";

const PhaseIII = (): JSX.Element => <PhaseIIIHero />;

export default PhaseIII;
